const quickView = ({ language, isSavedUser }) => {
  return {
    title: "Quick View",
    subtitle:
      "Compare products with crucial data available on the product or search result page",
    href: "https://chrome.google.com/webstore/detail/amazon-quick-view-by-amzs/pggamokfileohlopdonjmelbbghhnlah?utm_source=site&utm_medium=amzscout&utm_campaign=menu",
    isBlank: true,
  };
};

export default quickView;
